<template>
  <div class="popup-main">
    <el-dialog
      width="1220px"
      :title="isError ? '失败' : '导入数据'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <vxe-grid
        size="mini"
        height="400"
        :columns="columns"
        :data="list"
        :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa-pencil-square-o' }"
      />
      <div slot="footer">
        <el-button v-if="isError" size="mini" @click="popupCancel">取消</el-button>
        <el-button v-else size="mini" type="primary" @click="popupConfirm"> 确认 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    isError: {
      type: Boolean,
      refault: false
    },
    uuid: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      columns: [
        { field: 'supplier_name', width: 250, title: '供应商名称' },
        { field: 'linkman', width: 120, title: '联系人' },
        { field: 'linkman_phone', width: 120, title: '联系电话' },
        { field: 'remark', width: 400, title: '备注' },
        {
          field: 'error',
          width: 180,
          title: '#',
          slots: {
            default: ({ row }) => {
              return [<el-link type="danger">{row.error}</el-link>]
            }
          }
        }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
  },
  methods: {
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$api({
        method: 'get',
        url: '/admin/supplier/saveImportExcel',
        params: {
          uuid: this.uuid
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.popupCancel()
          this.$emit('success')
          this.$message.success('导入成功')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
